// extracted by mini-css-extract-plugin
module.exports = {"ratio":"video-embed-module--ratio--2tXiK","video":"video-embed-module--video--uvl8E"};